import { Injectable } from '@angular/core';
import { NoticesApi } from './notices/notices.api';

@Injectable()
export class InfoPostApi {
  constructor(public notices: NoticesApi) {}
}
